import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ahaui/ahaui/apps/docs/src/layouts/ApiLayout.js";
import { graphql } from 'gatsby';
import ComponentApi from 'src/components/ComponentApi';
import CodeView from 'src/components/CodeView';
import desktopHeader from 'src/examples/Header/desktop';
import mobileHeader from 'src/examples/Header/mobile';
import loginHeader from 'src/examples/Header/login';
export const query = graphql`
  query HeaderQuery {
    Header: componentMetadata(displayName: { eq: "Header" }) {
      ...ComponentApi_metadata
    }
    HeaderContext: componentMetadata(displayName: { eq: "HeaderContext" }) {
      ...ComponentApi_metadata
    }
    HeaderMobile: componentMetadata(displayName: { eq: "HeaderMobile" }) {
      ...ComponentApi_metadata
    }
  }
`;
export const _frontmatter = {};
const layoutProps = {
  query,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "header"
    }}>{`Header`}</h1>
    <h2 {...{
      "id": "introduction"
    }}>{`Introduction`}</h2>
    <p>{`Header structure is a template that explains the areas in the header and how it work which helps combine other components to create a consistent user experience.`}</p>
    <h3 {...{
      "id": "default"
    }}>{`Default`}</h3>
    <img src={require('src/assets/structure/default-header-structure.jpg')} srcSet={`${require('src/assets/structure/default-header-structure@2x.jpg')} 2x`} alt="Header structure" className="u-maxWidthFull" />
    <ol className="u-textGray u-marginTopTiny">
  <li>Container: Using container to wrap header contents and grid system to set fix-width or full-width header.</li>
  <li>Logo: Using this area for logo of the site.</li>
  <li>Main content wrapper: Used to wrap all the header contents, except logo. This part is also replaced by a hamburger button on mobile.</li>
  <li>Right: Often used to present icons, CTA buttons or components about users' account.</li>
  <li>Left: Often used to display top menu of the site.</li>
    </ol>
    <h3 {...{
      "id": "absolute"
    }}>{`Absolute`}</h3>
    <img src={require('src/assets/structure/absolute-header-structure.jpg')} srcSet={`${require('src/assets/structure/absolute-header-structure@2x.jpg')} 2x`} alt="Header structure" className="u-maxWidthFull" />
    <ol className="u-textGray u-marginTopTiny">
  <li>Container: Using container to wrap header contents and grid system to set fix-width or full-width header.</li>
  <li>Logo: Using this area for logo of the site.</li>
  <li>Main content wrapper: Used to wrap all the header contents, except logo. This part is also replaced by a hamburger button on mobile.</li>
  <li>Right: Often used to present icons, CTA buttons or components about users' account.</li>
  <li>Absolute center-aligned objects: Using this area to display the components which are always center-aligned such as a countdown or session remaining component in workspace.</li>
    </ol>
    <h2 {...{
      "id": "examples"
    }}>{`Examples`}</h2>
    <h3 {...{
      "id": "desktop-layout"
    }}>{`Desktop layout`}</h3>
    <p>{`Note: Only "LEFT" area or "CENTER" area is shown up at a time.`}</p>
    <CodeView transparentBackground codeText={desktopHeader} mdxType="CodeView" />
    <h3 {...{
      "id": "mobile-layout"
    }}>{`Mobile layout`}</h3>
    <CodeView transparentBackground codeText={mobileHeader} mdxType="CodeView" />
    <h3 {...{
      "id": "examples-1"
    }}>{`Examples`}</h3>
    <CodeView transparentBackground codeText={loginHeader} mdxType="CodeView" />
    <h2 {...{
      "id": "api"
    }}>{`API`}</h2>
    <ComponentApi metadata={props.data.Header} mdxType="ComponentApi" />
    <ComponentApi metadata={props.data.HeaderContext} exportedBy={props.data.HeaderMobile} mdxType="ComponentApi" />
    <ComponentApi metadata={props.data.HeaderMobile} mdxType="ComponentApi" />


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      